var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._g(_vm._b({model:{value:(_vm.formattedDateRange),callback:function ($$v) {_vm.formattedDateRange=$$v},expression:"formattedDateRange"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }